import { useState } from "react";
import { genres } from "@/mocks/genres";
import SectionHeading from "./SectionHeading";

export default function GenreSection() {
  const [active, setActive] = useState(genres[0].id);
  const current = genres.find((g) => g.id === active) ?? genres[0];

  return (
    <section id="genres" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Subgenres"
          title="题材细分：六个最常被讨论的方向"
          desc="伦理题材看似笼统，落到具体作品时往往会收束到某条主线上。点击下方标签，看看每个方向真正关心的问题是什么。"
        />

        <div className="mt-9 flex flex-wrap gap-2.5">
          {genres.map((g) => {
            const on = g.id === active;
            return (
              <button
                key={g.id}
                type="button"
                onClick={() => setActive(g.id)}
                aria-pressed={on}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full font-label text-sm whitespace-nowrap border transition-colors cursor-pointer ${
                  on
                    ? "bg-primary-500 text-background-50 border-primary-500"
                    : "bg-background-50 text-foreground-700 border-background-300/70 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                <i className={`${g.icon} text-base`}></i>
                {g.name}
              </button>
            );
          })}
        </div>

        <div className="mt-8 bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-3">
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${current.icon} text-2xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                    {current.name}
                  </h3>
                  <p className="font-label text-xs md:text-sm text-accent-700">{current.tagline}</p>
                </div>
              </div>
              <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">
                {current.description}
              </p>
            </div>

            <div className="lg:col-span-2 lg:border-l lg:border-background-200 lg:pl-8">
              <h4 className="font-label text-sm font-semibold tracking-wide text-foreground-950">
                典型议题
              </h4>
              <ul className="mt-4 space-y-3">
                {current.highlights.map((h) => (
                  <li key={h} className="flex items-start gap-2.5">
                    <i className="ri-checkbox-circle-fill text-accent-500 text-base mt-0.5 shrink-0"></i>
                    <span className="text-sm leading-relaxed text-foreground-700">{h}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}